<template>
  <discussion-forum-container v-if="canViewForum" v-bind="forumProps" />

  <div v-else-if="showLoginPrompt">
    <alert v-if="emailSent" alert-class="success">
      {{ emailSentMessage }}
    </alert>
    <p v-else @click="handleLoginOrMagicLinkClick" v-html="logInOrMagicLinkHtml" />
  </div>
</template>

<script>
import ajax from '../helpers/ajax'
import Alert from '../components/alert'
import DiscussionForumContainer from '../discussion-forum/discussion-forum-container'

export default {
  components: { Alert, DiscussionForumContainer },

  props: {
    initialCanViewForum: {
      type: Boolean,
      required: false,
      default: false
    },

    initialForumProps: {
      type: Object,
      required: true
    },

    initialSendMagicLinkUrl: {
      type: String,
      required: false
    },

    initialShowLoginPrompt: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      canViewForum: this.initialCanViewForum,
      emailSent: false,
      emailSentMessage: '',
      forumProps: this.initialForumProps,
      sendMagicLinkUrl: this.initialSendMagicLinkUrl,
      showLoginPrompt: this.initialShowLoginPrompt
    }
  },

  computed: {
    logInOrMagicLinkHtml() {
      const loginLink = `<a href="/users/sign_in">${this.i18n.t('events.forum_section.log_in')}</a>`

      const getMagicLinkText = this.i18n.t('events.forum_section.get_a_magic_link')
      const btnLinkClasses = 'btn btn-link d-inline p-0 border-0 align-baseline' // Make it look like a real link
      const sendSoftLoginLink = `<button class="send-soft-login ${btnLinkClasses}">${getMagicLinkText}</button>`

      return this.i18n.t('events.forum_section.login_or_soft_login_html',
                         {login_link: loginLink, send_soft_login_link: sendSoftLoginLink})
    }
  },

  mounted() {
    // When someone RSVPs, the agra:update-forum-context event will be sent.
    // We need to update this component's state based on the new data.
    document.addEventListener('agra:update-forum-context', (e) => {
      this.canViewForum = e.detail.canViewForum
      this.forumProps = e.detail.forumProps
      this.sendMagicLinkUrl = e.detail.sendMagicLinkUrl
      this.showLoginPrompt = e.detail.showLoginPrompt
    })
  },

  methods: {
    handleLoginOrMagicLinkClick(evt) {
      if (evt.target.classList.contains('send-soft-login')) {
        // The user has clicked on the "get a magic link" button
        ajax.put({
          url: this.sendMagicLinkUrl,
          successHandler: ({ message }) => {
            this.emailSentMessage = message
            this.emailSent = true
          }
        })
      }
    }
  }
}
</script>
